// RasporedTable.js

import React, { useMemo } from 'react';
import RasporedRow from './RasporedRow';
import '../css/RasporedTable.css'; // Provjeri da je ovaj CSS ažuriran prema gore

function RasporedTable({
  people = [],
  weekSchedules = [],
  updateWeekSchedule, // Primamo funkciju
  selectedNationality,
  selectedFirm,
  selectedYear,
  selectedWeek,
  firms = [],
}) {
  // Funkcija za dobivanje datuma početka tjedna
  function getDateOfISOWeek(w, y) {
    const simple = new Date(Date.UTC(y, 0, 1 + (w - 1) * 7));
    const dow = simple.getDay();
    let ISOweekStart = simple;
    if (dow <= 4)
      ISOweekStart.setDate(simple.getDate() - simple.getDay() + 1);
    else
      ISOweekStart.setDate(simple.getDate() + 8 - simple.getDay());
    return ISOweekStart;
  }

  // Generiramo dane u tjednu počevši od ponedjeljka
  const daysOfWeek = useMemo(() => {
    const weekStartDate = getDateOfISOWeek(selectedWeek, selectedYear);
    if (!weekStartDate) {
      return []; // Ili možete prikazati poruku o grešci
    }
    return Array.from({ length: 7 }, (_, i) => {
      const date = new Date(weekStartDate);
      date.setDate(weekStartDate.getDate() + i);
      return {
        date,
        dayName: date.toLocaleDateString('hr-HR', { weekday: 'long' }),
      };
    });
  }, [selectedYear, selectedWeek]);

  // Kreiranje mape firmi za brže dohvaćanje
  const firmMap = useMemo(() => {
    const map = {};
    firms.forEach((firm) => {
      map[firm.id] = firm.name;
    });
    return map;
  }, [firms]);

  // Funkcija za dohvaćanje imena firme koristeći mapu
  const getFirmName = (firmId) => {
    return firmMap[firmId] || 'N/A';
  };

  // Filtriramo ljude prema filtrima i isključujemo arhivirane osobe
  const filteredPeople = useMemo(() => {
    return people
      .filter((person) => {
        const matchesNationality = selectedNationality === 'Sve' || person.nationality === selectedNationality;
        const matchesFirm = selectedFirm === '' || person.firmId === selectedFirm;
        const notArchived = !person.archived; // Dodani uvjet za arhivirane osobe
        return matchesNationality && matchesFirm && notArchived;
      })
      .filter((person) => person.name) // Filtriramo osobe bez imena
      .sort((a, b) => {
        // Prvo sortiramo po firmama
        const firmA = firms.find(firm => firm.id === a.firmId)?.name || '';
        const firmB = firms.find(firm => firm.id === b.firmId)?.name || '';
        const firmComparison = firmA.localeCompare(firmB);

        // Ako su firme iste, sortiramo po nacionalnosti
        if (firmComparison === 0) {
          return a.nationality.localeCompare(b.nationality);
        }
        return firmComparison;
      });
  }, [people, selectedNationality, selectedFirm, firms]);

  return (
    <div className="raspored-table-container">
      {/* Prikaz broja osoba */}
      <div className="table-header">
        <span className="people-count">
          Prikazano osoba: {filteredPeople.length}
        </span>
      </div>

      <table className="raspored-table">
        <thead>
          <tr>
            <th rowSpan={2}>Ime</th>
            <th rowSpan={2}>Akcije</th>
            <th rowSpan={2}>Rider ID</th>
            <th rowSpan={2}>Firma</th>
            <th rowSpan={2}>Nacionalnost</th>
            {daysOfWeek.map((day, index) => (
              <th key={`day-${index}`} colSpan={2}>
                {day.dayName}
              </th>
            ))}
            <th rowSpan={2}>Ukupno Tjedan</th>
          </tr>
          <tr>
            {daysOfWeek.map((day, index) => (
              <React.Fragment key={`date-${index}`}>
                <th>{day.date.toLocaleDateString('hr-HR')}</th>
                <th>Ukupno</th>
              </React.Fragment>
            ))}
          </tr>
        </thead>
        <tbody>
          {filteredPeople.length > 0 ? (
            filteredPeople.map((person) => (
              <RasporedRow
                key={person.id}
                person={person}
                weekSchedules={weekSchedules}
                updateWeekSchedule={updateWeekSchedule}
                daysOfWeek={daysOfWeek}
                firms={firms}
                colSpan={daysOfWeek.length * 2 + 7}
              />
            ))
          ) : (
            <tr>
              <td colSpan={daysOfWeek.length * 2 + 7} style={{ textAlign: 'center' }}>
                Nema prikazanih osoba.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default RasporedTable;
